module.exports = __webpack_public_path__ + "static/img/maintenancetips.7011cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maintenancetips.jpg
// module id = MzRM
// module chunks = 1